export const PLATFORMS = Object.freeze({
  FRENCH: 'FR',
  BRITANNIC: 'GB',
  GERMAN: 'DE',
  SPANISH: 'ES',
  ITALIAN: 'IT',
});

/**
 * Variable injected by webpack
 * https://git.manomano.tech/core-utils/js-tools/blob/master/packages/webpack/plugins.js#L115
 */
export const CURRENT_PLATFORM = __PLATFORM__; // eslint-disable-line no-undef
